import { VALID } from 'common/const';

const FIELD = {
  address1: {
    label: 'Address 1',
    placeholder: 'Street, Building, Room, etc',
    validation: VALID.ADDRESS.required('Address is required'),
  },
  address2: {
    label: 'Address 2',
    optional: true,
    placeholder: 'District',
    validation: VALID.ADDRESS_2,
  },
  city: {
    label: 'City',
    validation: VALID.CITY.required('City is required'),
  },
  state: {
    label: 'Province',
    validation: VALID.PROVINCE.required('Province is required'),
  },
  zip: {
    label: 'Postal Code',
    validation: VALID.POSTAL_CODE.required('Postal code is required'),
  },
};

export default FIELD;
